// store/loggerSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LogEntry } from "@app/data/logger/type";

interface LoggerState {
  logs: LogEntry[];
}

const initialState: LoggerState = {
  logs: [],
};
const loggerSlice = createSlice({
  name: 'logger',
  initialState,
  reducers: {
    addLog(
      state,
      action: PayloadAction<Omit<LogEntry, 'id' | 'timestamp'>>
    ) {
      state.logs.push({
        id: crypto.randomUUID(),
        timestamp: new Date().toISOString(),
        ...action.payload,
      });
    },
    clearLogs(state) {
      state.logs = [];
    },
  },
});

export const { addLog, clearLogs } = loggerSlice.actions;
export default loggerSlice.reducer;